/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class t{constructor(t,s=0){this.geometry=t,this.stateMask=s}}export{t as RenderObject};
